import { render, staticRenderFns } from "./wty-shopinfo.vue?vue&type=template&id=71b3f7e3&scoped=true&"
import script from "./wty-shopinfo.vue?vue&type=script&lang=js&"
export * from "./wty-shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./wty-shopinfo.vue?vue&type=style&index=0&id=71b3f7e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3f7e3",
  null
  
)

export default component.exports